module.exports = __webpack_public_path__ + "static/media/age-sm.69d9df01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/age-sm.jpg
// module id = 160
// module chunks = 13